import React from "react";
import { observer, inject } from "mobx-react";
import { Formik, Field, Form, FieldArray } from 'formik';


@inject("store")
@observer
export default class AddressEdit extends React.Component {


    constructor(props) {
        super(props);
        this.validateAddress = this.validateAddress.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }
    validateAddress(values) {
        let errors = {};

        // Validate shipping
        if (!values.shippingFirstName) {
            errors.shippingFirstName = 'Required';
        }
        if (!values.shippingLastName) {
            errors.shippingLastName = 'Required';
        }

        if (!values.shippingPhoneNumber) {
            errors.shippingPhoneNumber = 'Required';
        }

        if (!values.shippingEmailAddress) {
            errors.shippingEmailAddress = 'Required';
        }

        if (!values.shippingCity) {
            errors.shippingCity = 'Required';
        }

        if (!values.shippingPostalCode) {
            errors.shippingPostalCode = 'Required';
        }

        if (!values.shippingLine2) {
            errors.shippingLine2 = 'Required';
        }
        if (!values.shippingCountryName) {
            errors.shippingCountryName = 'Required';
        }
        console.log("errors-form", errors);
        return errors;
    }

    async handleBlur(values) {
        if (typeof (values) === "undefined") {
            return null;
        }
        const order = this.props.store.order.activeOrder;

        const changes = {
            shippingAddress: {
                FirstName: values.shippingFirstName,
                LastName: values.shippingLastName,
                EmailAddress: values.shippingEmailAddress,
                PhoneNumber: values.shippingPhoneNumber,
                Company: values.shippingCompany,
                Line1: values.shippingLine1,
                Line2: values.shippingLine2,
                PostalCode: values.shippingPostalCode,
                City: values.shippingCity
            }
        };

        order.updateShippingAddress(changes);
    }

    handleChange(props, fieldName, fieldValue) {
        props.setFieldValue(fieldName, fieldValue);
        props.setFieldTouched(fieldName, true);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
    }

    render() {
        const order = this.props.order;
        const navigation = this.props.store.navigation;
        const CallbackValidation = props => {
            const { isValid } = props;
            React.useEffect(() => {
                this.props.isValidCallback(isValid);
            }, [isValid]);
            return null;
        };
        return (
            <div className="row">
                <Formik
                    countryName={order.BillingAddress.CountryName}
                    state={this.state}
                    initialValues={{
                        shippingFirstName: order.ShippingAddress ? order.ShippingAddress.FirstName : "",
                        shippingLastName: order.ShippingAddress ? order.ShippingAddress.LastName : "",
                        shippingEmailAddress: order.ShippingAddress ? order.ShippingAddress.EmailAddress : "",
                        shippingPhoneNumber: order.ShippingAddress ? order.ShippingAddress.PhoneNumber : "",
                        shippingCompany: order.ShippingAddress ? order.ShippingAddress.Company : "",
                        shippingLine1: order.ShippingAddress ? order.ShippingAddress.Line1 : "",
                        shippingLine2: order.ShippingAddress ? order.ShippingAddress.Line2 : "",
                        shippingPostalCode: order.ShippingAddress ? order.ShippingAddress.PostalCode : "",
                        shippingCity: order.ShippingAddress ? order.ShippingAddress.City : "",
                        shippingCountryName: order.BillingAddress.CountryName || "",
                    }}
                    validate={this.validateAddress}
                    render={(props) => {
                        const { values, errors, touched, isSubmitting, isValid, status } = props;
                        return (
                            <div className="col-12">
                                <Form id="address-form" className="custom-order-address">
                                    <div className="row">
                                        <div className="col-6">
                                            {/*(touched.shippingFirstName && errors.shippingFirstName ? "has-danger" : "")*/}
                                            <div className={" " + (errors.shippingFirstName ? "has-danger" : "")} >
                                                <label htmlFor="checkout-fn">{navigation.dictionary.FirstName}*</label>
                                                <Field className="form-control" name="shippingFirstName" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingFirstName', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingFirstName && touched.shippingFirstName &&
                                                    <div className="form-control-feedback">{errors.shippingFirstName}</div>}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingLastName && errors.shippingLastName ? "has-danger" : "")} >
                                                <label htmlFor="checkout-ln">{navigation.dictionary.LastName}*</label>
                                                <Field className="form-control" name="shippingLastName" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingLastName', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingLastName &&
                                                    touched.shippingLastName &&
                                                    <div className="form-control-feedback">{errors.shippingLastName}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingPhoneNumber && errors.shippingPhoneNumber ? "has-danger" : "")} >
                                                <label htmlFor="checkout-phone">{navigation.dictionary.PhoneNumber}*</label>
                                                <Field className="form-control" name="shippingPhoneNumber" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingPhoneNumber', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingPhoneNumber &&
                                                    touched.shippingPhoneNumber &&
                                                    <div className="form-control-feedback">{errors.shippingPhoneNumber}</div>}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingEmailAddress && errors.shippingEmailAddress ? "has-danger" : "")} >
                                                <label htmlFor="checkout-phone">{navigation.dictionary.Emailaddress}*</label>
                                                <Field className="form-control" name="shippingEmailAddress" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingEmailAddress', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingEmailAddress &&
                                                    touched.shippingEmailAddress &&
                                                    <div className="form-control-feedback">{errors.shippingEmailAddress}</div>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingLine2 && errors.shippingLine2 ? "has-danger" : "")} >
                                                <label htmlFor="checkout-address2">{navigation.dictionary.Address2}*</label>
                                                <Field className="form-control" name="shippingLine2" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingLine2', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingLine2 &&
                                                    touched.shippingLine2 &&
                                                    <div className="form-control-feedback">{errors.shippingLine2}</div>}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingLine1 && errors.shippingLine1 ? "has-danger" : "")} >
                                                <label htmlFor="checkout-address1">{navigation.dictionary.Address1}</label>
                                                <Field className="form-control" name="shippingLine1" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingLine1', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingLine1 &&
                                                    touched.shippingLine1 &&
                                                    <div className="form-control-feedback">{errors.shippingLine1}</div>}
                                            </div>
                                        </div> 
                                        
                                    </div>
                                    <div className="row">
                                        <div className="col-6">
                                            <div className={"" + (touched.shippingCity && errors.shippingCity ? "has-danger" : "")} >
                                                <label htmlFor="checkout-city">{navigation.dictionary.City}*</label>
                                                <Field className="form-control" name="shippingCity" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingCity', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingCity &&
                                                    touched.shippingCity &&
                                                    <div className="form-control-feedback">{errors.shippingCity}</div>}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className={" " + (touched.shippingPostalCode && errors.shippingPostalCode ? "has-danger" : "")} >
                                                <label htmlFor="checkout-zip">{navigation.dictionary.ZipCode}*</label>
                                                <Field className="form-control" name="shippingPostalCode" type="text" placeholder="" onChange={(e) => this.handleChange(props, 'shippingPostalCode', e.target.value)} onBlur={() => this.handleBlur(values)} />
                                                {errors.shippingPostalCode &&
                                                    touched.shippingPostalCode &&
                                                    <div className="form-control-feedback">{errors.shippingPostalCode}</div>}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row ">
                                        <div className="col-sm-12">
                                            <div className="">
                                                <label htmlFor="checkout-country">{navigation.dictionary.Country}</label>
                                                <Field className="form-control" name="shippingCountryName" type="text" placeholder="" disabled={true} />
                                            </div>
                                        </div>
                                    </div>
                                    <CallbackValidation isValid={isValid} />
                                    {errors.custom && <div>{errors.custom}</div>}
                                </Form>
                            </div>
                        );
                    }}
                />
            </div >
        );
    }
}